// import {scripts} from './../../package.json'

export const {
  LOGIN_PATH,
  NODE_ENV,
  VUE_APP_IMG_URL,
  VUE_APP_PTYPE,
  LOGIN_CLIENT_ID,
  LOGIN_CLIENT_SECRET,
} = (() => {
  let {
    VUE_APP_LOGIN_PATH,
    VUE_APP_LOGIN_CLIENT_ID,
    VUE_APP_LOGIN_CLIENT_SECRET,
    VUE_APP_PARK,
  } = process.env;
  console.log(process.env);
  if (!VUE_APP_LOGIN_CLIENT_ID) {
    VUE_APP_LOGIN_CLIENT_ID = "one_ent_one_file";
    VUE_APP_LOGIN_CLIENT_SECRET = "ido85R&EntFile";
  }
  let loginPath = VUE_APP_LOGIN_PATH;
  if (VUE_APP_PARK === "tx") {
    if (location.hostname !== "58.222.192.26") {
      loginPath = loginPath.replace("58.222.192.26", location.hostname);
    }
  }
  return {
    LOGIN_PATH: loginPath,
    LOGIN_CLIENT_ID: VUE_APP_LOGIN_CLIENT_ID,
    LOGIN_CLIENT_SECRET: VUE_APP_LOGIN_CLIENT_SECRET,
    ...process.env,
  };
})();

console.log(
  "%c%s",
  "color: red; background: yellow; font-size: 12px;padding:0px 10px;",
  `当前统一登录地址为：${LOGIN_PATH}`
);

console.log(
  "%c%s",
  "color: red; background: yellow; font-size: 12px;padding:0px 10px;",
  `当前环境为${NODE_ENV}`
);
